namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmStrukturaVlastnostiObsah extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmStrukturaVlastnostiObsahReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmStrukturaVlastnostiObsahObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmStrukturaVlastnostiObsahObj());
            this.detailObj.createBase({
                contentName: "detailAdmStrukturaVlastnostiObsah",
                contentCaption: "jres:33000465", //RC 33000465 : Vlastnosti struktury
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmStrukturaVlastnostiObsah", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmStrukturaVlastnostiObsahObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmStrukturaVlastnostiObsahReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0} - {1}".format((this.data.ixs_stv_txt) ? this.data["ixs_stv_txt"] : "", (this.data.ixs_vla_txt) ? this.data["ixs_vla_txt"] : "")
        }

        setSxsDetail(): string {
            return "{0}#{1}#".format((this.data.ixs_stv) ? this.data.ixs_stv : "", (this.data.ixs_vla) ? this.data.ixs_vla : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmStrukturaVlastnostiObsahSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmStrukturaVlastnostiObsah.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => { this.cnt.close() });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            // Nen� nutno otev�rat detail
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmStrukturaVlastnostiObsah", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmStrukturaVlastnostiObsah.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1} x {2}".format(this.options.contentCaption, (this.data.ixs_stv_txt) ? this.data.ixs_stv_txt : "", (this.data.ixs_vla_txt) ? this.data.ixs_vla_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actNovaAdmVlastnost: {
                    caption: "jres:33000555", //RC 33000555 : Nov� vlastnost
                    icon: "gi-plus",
                    run: (ev, ctx) => {
                        this.openNewVlastnost();
                    }
                }
            }
            //return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ixs_stv", Gordic.Prefabs.Select.ginsstv(), { model: "model.ixs_stv=value.ixs_stv" });
            this.MakeSelectField("ixs_vla", Gordic.Prefabs.Select.ginsvla(), {
                model: "model.ixs_vla=value.ixs_vla",
                dropdown: false,
                buttons: [
                    {
                        type: "static",
                        icon: "gi-plus",
                        captionVisible: "never",
                        children: [
                            { action: this.cnt.actions.actNovaAdmVlastnost }
                        ]
                    }
                ]
            });
            this.MakeField("k_v");
            this.MakeField("kod_form");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private openNewVlastnost() {
            $.content().dialogs.showModalWindow(["Gordic.Adm.WebControls.DetailAdmVlastnost", {
                returnValue: true,
                openModal: true
            }], {
                ID: "DetailAdmVlastnost",
                newRecord: true,
                ixs_vla: null
            }, {
                height: 800,
                width: 800
            }).on("close", (ev, obj) => {
                if (obj)
                    if (obj.ixs_vla)
                        this.cnt.findFields("ixs_vla").gfield("setValue", { ixs_vla: obj.ixs_vla }, false)
            })
        }
    }
}
